import { PROVIDER_NAMES } from 'common/constants/constants';

const providersWithOrgs = [PROVIDER_NAMES.github, PROVIDER_NAMES.azure_devops];

/**
 * Checks if a provider supports organizations
 * @param {string} sensorName
 * @returns {boolean}
 */
export const isProviderWithOrgs = sensorName => {
  return providersWithOrgs.includes(sensorName);
};
